exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "body {\n  margin: 0;\n  padding: 0;\n  font-family: sans-serif;\n  overflow: hidden; }\n\ni,\nins {\n  font-style: normal;\n  text-decoration: none; }\n\nul {\n  padding: 0; }\n  ul li {\n    list-style: none !important; }\n\nul,\nli {\n  margin: 0;\n  padding: 0; }\n\np {\n  margin: 0; }\n\n.c_inline {\n  display: inline-block; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./src/styles/reset.scss
// module id = 859
// module chunks = 0